// Apply `inert` to the app shell behind an open modal so AT and keyboard
// users cannot reach background content — pairs with aria-modal="true".
// Targets the .app-shell node directly; modals are portaled to document.body
// so they sit outside the inert subtree.

import { useEffect } from 'react';

export function useInertBackground(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const targets = Array.from(document.querySelectorAll<HTMLElement>('.app-shell'));
    for (const el of targets) el.setAttribute('inert', '');
    return () => {
      for (const el of targets) el.removeAttribute('inert');
    };
  }, [active]);
}
